export const LTT_GROUP_BOOKING_URL =
  'http://london-theater-tickets.com/group-tickets/enquiry';
